import { render, staticRenderFns } from "./ResultsCard.vue?vue&type=template&id=4f631084&scoped=true&"
import script from "./ResultsCard.vue?vue&type=script&lang=js&"
export * from "./ResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultsCard.vue?vue&type=style&index=0&id=4f631084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f631084",
  null
  
)

export default component.exports